import React, { Component } from "react";

import { CCol, CRow } from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../../actions/baseActions";
import { setObj } from "../../../../../actions/noteActions";
import Breadcrumb from "../../../../../components/Breadcrumb";
import Cards from "../../../../../components/Cards/Cards";
import Charts from "../../../../../components/Charts";
import Loading from "../../../../../components/Loading";
import ProtectedRoute from "../../../../../components/ProtectedRoute";
import Widgets from "../../../../../components/Widgets/Widgets";
import URL from "../../../../../config/api";
import axios from "../../../../../config/axios";
import { formatDate } from "../../../../../utils/date";

import "../../../../../scss/style2.scss";

const FileDownload = require("js-file-download");

class ActivityTVReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      activity_id: this.props.match.params.activity_id,
      activity_name: "",
      activity_description_box: {},
      executionItems: [],
      distribution: []
    };

    this.error = this.error.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Fail", response);
    }
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    let objApplication = {
      activity_id: this.state.activity_id
    };

    axios
      .all([
        axios.get(
          `${URL.api}activity/activity/singleView/${this.state.activity_id}`,
          { headers: { authorization: `Bearer ${this.props.user.token}` } }
        ),
        // axios.post(URL.api + 'evaluation/application/list', obj_application, {headers: {'authorization': 'Bearer ' + this.props.user.token}}),
        axios.get(
          `${URL.api}activity/execution/reportByItem?activity_id=${this.state.activity_id}`,
          { headers: { authorization: `Bearer ${this.props.user.token}` } }
        ),
        axios.get(
          `${URL.api}statistics/activity_users_distribution?activity_id=${this.state.activity_id}`,
          { headers: { authorization: `Bearer ${this.props.user.token}` } }
        )
      ])
      .then(
        axios.spread(
          (respAcivity, respExecution, respDistribution) => {
            for (let i = 0; i < respAcivity.data.data.items.length; i++) {
              respAcivity.data.data.items[i].title =
                respAcivity.data.data.items[i].name;
              respAcivity.data.data.items[i].quantityNote = 0;
              respAcivity.data.data.items[i].sumNote = 0;
              respAcivity.data.data.items[i].listNote = [];
            }

            this.setState({
              loading: false,
              activity_name: respAcivity.data.data.name,
              activity_description_box: {
                type: 0,
                text: respAcivity.data.data.description
              },
              itens: respAcivity.data.data.items,
              executionItems: respExecution.data.data.items,
              distribution: respDistribution.data.data
            });
          },
          error => {
            this.error(error.response.statusText);
          }
        )
      );
  }

  openItem = item => {
    if (item.type_id === 12) {
      axios
        .get(`${URL.api}download/${item.link}`, {
          headers: { authorization: `Bearer ${this.props.user.token}` },
          responseType: "blob"
        })
        .then(resp => {
          FileDownload(resp.data, `${item.name}.png`);
        });
    }
  };

  getFinalGradeAverage(users) {
    const filtered = users.filter(user => user.final_grade !== null);

    if (filtered.length === 0) {
      return "";
    }

    return (
      filtered.reduce((acc, val) => acc + parseFloat(val.final_grade || 0), 0) /
      filtered.length
    ).toFixed(2);
  }

  getPercentageAverage(users) {
    const filtered = users.filter(user => user.completion_percentage !== null);

    if (filtered.length === 0) {
      return "";
    }

    return `${(
      filtered.reduce(
        (acc, val) => acc + parseFloat(val.completion_percentage || 0),
        0
      ) / filtered.length
    ).toString()}%`;
  }

  render() {
    return (
      <React.Fragment>
        <Breadcrumb current={this.props.currentRoute} />
        {!this.state.loading ? (
          <>
            <CRow>
              <CCol lg="12">
                <Cards
                  header={this.state.activity_name}
                  body={this.state.activity_description_box}
                  footer=""
                />
              </CCol>
            </CRow>
            <CRow>
              <React.Fragment>
                <CCol lg="12">
                  <div id="leftSide">
                    <Widgets
                      itens={this.state.itens}
                      openItem={this.openItem}
                    />
                  </div>
                </CCol>
              </React.Fragment>
            </CRow>
            {this.state.executionItems.map((item, index) => (
              <div key={index} className="mb-4">
                <div>
                  <header
                    className="card-header d-flex"
                    style={{ border: "1px solid #c8ced3" }}
                  >
                    <div
                      className="d-flex mr-3 font-weight-bold align-items-center"
                      style={{ flex: 3 }}
                    >
                      <i className="fa fa-bar-chart mr-2"></i> {item.name}
                    </div>
                    <div
                      className="d-flex mr-3 font-weight-bold"
                      style={{ flex: 2 }}
                    >
                      Início
                    </div>
                    <div
                      className="d-flex mr-3 font-weight-bold"
                      style={{ flex: 2 }}
                    >
                      Fim
                    </div>
                    <div
                      className="d-flex mr-3 font-weight-bold"
                      style={{ flex: 1 }}
                    >
                      Porcentagem
                    </div>
                    <div
                      className="d-flex mr-3 font-weight-bold"
                      style={{ flex: 1 }}
                    >
                      Nota
                    </div>
                  </header>
                  {item.users.map((user, index) => (
                    <React.Fragment key={index}>
                      <header
                        className="card-header"
                        style={{ border: "1px solid #c8ced3", borderTop: "0" }}
                      >
                        <div style={{ display: "flex" }}>
                          <div
                            className="d-flex mr-3 align-items-center"
                            style={{ flex: 3 }}
                          >
                            <img
                              src={
                                URL.img +
                                (user.user_photo ||
                                  "uploads/users/profileEmpty.jpg")
                              }
                              className="rounded-circle mr-2"
                              style={{ width: "24px", height: "24px" }}
                              alt={user.user_name}
                            />
                            {user.user_name}
                          </div>
                          <div className="d-flex mr-3" style={{ flex: 2 }}>
                            {formatDate(user.start)}
                          </div>
                          <div className="d-flex mr-3" style={{ flex: 2 }}>
                            {formatDate(user.end)}
                          </div>
                          <div className="d-flex mr-3" style={{ flex: 1 }}>
                            {user.completion_percentage}%
                          </div>
                          <div className="d-flex mr-3" style={{ flex: 1 }}>
                            {user.final_grade}
                          </div>
                        </div>
                      </header>
                    </React.Fragment>
                  ))}
                  {item.users.length > 0 ? (
                    <header
                      className="card-header bg-light text-muted"
                      style={{
                        border: "1px solid #c8ced3",
                        borderTop: "0",
                        borderBottomLeftRadius: "0.5rem",
                        borderBottomRightRadius: "0.5rem"
                      }}
                    >
                      <div className="d-flex">
                        <div className="d-flex mr-3" style={{ flex: 3 }}>
                          Média
                        </div>
                        <div className="d-flex mr-3" style={{ flex: 2 }}></div>
                        <div className="d-flex mr-3" style={{ flex: 2 }}></div>
                        <div className="d-flex mr-3" style={{ flex: 1 }}>
                          {this.getPercentageAverage(item.users)}
                        </div>
                        <div className="d-flex mr-3" style={{ flex: 1 }}>
                          {this.getFinalGradeAverage(item.users)}
                        </div>
                      </div>
                    </header>
                  ) : (
                    <header
                      className="card-header"
                      style={{
                        border: "1px solid #c8ced3",
                        borderTop: "0",
                        borderBottomLeftRadius: "0.5rem",
                        borderBottomRightRadius: "0.5rem"
                      }}
                    >
                      <div className="d-flex align-items-center justify-content-center text-muted">
                        Nenhum registro
                      </div>
                    </header>
                  )}
                </div>
              </div>
            ))}
            <div className="card p-4">
              <Charts
                type="pie"
                title="Distribuição de usuários na atividade"
                data={{
                  labels: this.state.distribution.map(item => item.name),
                  datasets: [
                    {
                      data: this.state.distribution.map(item => item.count),
                      backgroundColor: [
                        "rgba(255, 99, 132, 0.2)",
                        "rgba(75, 192, 192, 0.2)",
                        "rgba(232, 151, 40, 0.2)",
                        "rgba(28, 49, 244, 0.2)",
                        "rgba(139, 71, 201, 0.2)",
                        "rgba(204, 164, 69, 0.2)",
                        "rgba(39, 233, 208, 0.2)"
                      ],
                      borderColor: [
                        "rgba(255, 99, 132, 1)",
                        "rgba(75, 192, 192, 1)",
                        "rgba(232, 151, 40, 1)",
                        "rgba(28, 49, 244, 1)",
                        "rgba(139, 71, 201, 1)",
                        "rgba(204, 164, 69, 1)",
                        "rgba(39, 233, 208, 1)"
                      ],
                      borderWidth: 1
                    }
                  ]
                }}
              />
            </div>
            <ProtectedRoute routeId={this.props.currentRoute} />
          </>
        ) : (
          <Loading top="45" left="50" />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityTVReport);
